import { render, staticRenderFns } from "./dots-loader.vue?vue&type=template&id=343e4b5c&scoped=true"
import script from "./dots-loader.vue?vue&type=script&lang=ts&setup=true"
export * from "./dots-loader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./dots-loader.vue?vue&type=style&index=0&id=343e4b5c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343e4b5c",
  null
  
)

export default component.exports